<template>
  <div class="dialogue-manage">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>接入</el-breadcrumb-item>
        <el-breadcrumb-item>对话管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <div class="page-header">
      <div class="page-title">对话管理</div>
      <div class="page-desc">
        聚合管理智能体接入渠道的全部对话，AI回复/人工回复智能切换。
        <br>
        一站式管理全渠道的对话用户，基于智能的数据分析添加客户标签、生成客户档案。
        <el-link type="primary" icon="el-icon-document">前往文档中心</el-link>
      </div>
      <el-button type="primary" class="upgrade-btn">前往升级</el-button>
    </div>
    
    <el-card class="function-card">
      <div class="function-grid">
        <div class="function-item">
          <div class="function-icon blue-icon">
            <i class="el-icon-chat-line-round"></i>
          </div>
          <div class="function-content">
            <div class="function-title">会话管理</div>
            <div class="function-desc">聚合展示全渠道用户与智能体的对话消息实时同步，会话记录可导出</div>
            <div class="function-tag">专业版 <i class="el-icon-check"></i></div>
          </div>
        </div>
        
        <div class="function-item">
          <div class="function-icon green-icon">
            <i class="el-icon-s-custom"></i>
          </div>
          <div class="function-content">
            <div class="function-title">转人工处理 <i class="el-icon-arrow-right"></i></div>
            <div class="function-desc">结合权限管理能力设置客服坐席，转人工后智能生成对话结构化卡片，AI回复/人工回复一键切换</div>
            <div class="function-tag">专业版 <i class="el-icon-check"></i></div>
          </div>
        </div>
        
        <div class="function-item">
          <div class="function-icon purple-icon">
            <i class="el-icon-user"></i>
          </div>
          <div class="function-content">
            <div class="function-title">客户管理 <i class="el-icon-arrow-right"></i></div>
            <div class="function-desc">一站式管理全渠道与智能体对话的用户，多种方式智能生成AI客户标签，一键直达客户档案</div>
            <div class="function-tag">企业版 <i class="el-icon-check"></i></div>
          </div>
        </div>
      </div>
    </el-card>
    
    <div class="section-title">功能配置</div>
    
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="config-card">
          <div class="config-header">
            <div class="config-icon blue-light-bg">
              <i class="el-icon-chat-line-round"></i>
            </div>
            <div class="config-title">对话策略配置</div>
          </div>
          <div class="config-content">
            <p>选择应用/工作流，一键开启自建渠道，托管接入渠道私聊、群聊的智能对话能力</p>
            <p>设置触发词、欢迎语等</p>
          </div>
          <div class="config-footer">
            <el-tag size="small" type="success">标准版 <i class="el-icon-check"></i></el-tag>
          </div>
        </el-card>
      </el-col>
      
      <el-col :span="8">
        <el-card class="config-card">
          <div class="config-header">
            <div class="config-icon cyan-light-bg">
              <i class="el-icon-data-line"></i>
            </div>
            <div class="config-title">离线监控通知</div>
          </div>
          <div class="config-content">
            <p>实时监控接入渠道的智能体运行状态</p>
            <p>离线及时发送短信，公众号消息通知保障 AI 服务稳定运行</p>
          </div>
          <div class="config-footer">
            <el-tag size="small" type="success">标准版 <i class="el-icon-check"></i></el-tag>
          </div>
        </el-card>
      </el-col>
      
      <el-col :span="8">
        <el-card class="config-card">
          <div class="config-header">
            <div class="config-icon indigo-light-bg">
              <i class="el-icon-connection"></i>
            </div>
            <div class="config-title">网页嵌入配置 <i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="config-content">
            <p>设置个性化的网页嵌入对话窗样式</p>
            <p>配置 Web 站点中无需展示对话框的页面，开启浮窗、语音输入及转人工能力</p>
          </div>
          <div class="config-footer">
            <el-tag size="small" type="success">标准版 <i class="el-icon-check"></i></el-tag>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'DialogueManage'
}
</script>

<style scoped>
.dialogue-manage {
  padding-bottom: 50px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.page-header {
  background-color: #fff;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  position: relative;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}

.page-desc {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
}

.upgrade-btn {
  position: absolute;
  top: 24px;
  right: 24px;
}

.function-card {
  margin-bottom: 30px;
}

.function-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.function-item {
  display: flex;
  padding: 15px 0;
}

.function-icon {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-right: 15px;
}

.blue-icon { background-color: #409EFF; }
.green-icon { background-color: #67C23A; }
.purple-icon { background-color: #9C27B0; }

.function-content {
  flex: 1;
}

.function-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.function-title i {
  margin-left: 6px;
  color: #909399;
}

.function-desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 10px;
}

.function-tag {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: #67C23A;
}

.function-tag i {
  margin-left: 3px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 30px 0 20px;
}

.config-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.config-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.config-icon {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
  margin-right: 10px;
}

.blue-light-bg { background-color: #ecf5ff; color: #409EFF; }
.cyan-light-bg { background-color: #e6f7ff; color: #00BCD4; }
.indigo-light-bg { background-color: #eaecfb; color: #3F51B5; }

.config-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.config-title i {
  margin-left: 6px;
  color: #909399;
}

.config-content {
  flex: 1;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 15px;
}

.config-content p {
  margin: 8px 0;
}

.config-footer {
  margin-top: auto;
}
</style> 